import Api, { make, Response } from 'src/services/api'

import { AssignTree, PAssignTreeType } from 'src/types'

type GetSufixProps = {
  assign_tree_id: number
}

type GetSufixResponse = {
  sufix: string[]
}

type TreeResponse = {
  trees: AssignTree[]
}

export function getAll(): Promise<Response<TreeResponse>> {
  return make<TreeResponse, TreeResponse>({
    axiosCall: Api.get('trees'),
    /**
     * @todo
     * this transformData fixes an api failure
     * apparently user nodes shouldn't be displayed
     */
    transformData: data => ({
      trees: data.trees?.filter(
        tree => tree.p_assign_tree_type !== PAssignTreeType.USER
      )
    })
  })
}

export function getSufix({
  assign_tree_id
}: GetSufixProps): Promise<Response<string[]>> {
  return make<GetSufixResponse, string[]>({
    axiosCall: Api.get(`sufix?assign_tree_id=${assign_tree_id}`),
    transformData: data => data.sufix
  })
}

export function saveNode(node: AssignTree): Promise<Response<TreeResponse>> {
  return make<TreeResponse>({
    axiosCall: Api.post('trees', {
      trees: [node]
    })
  })
}
